import React from 'react';
import withAuthorization from 'components/Session/withAuthorization';
import { Typography } from '@material-ui/core';
import SectionFooter from 'views/SectionFooter';
import GuideHeader from '../../components/GuideHeader';
import GuideContent from '../../components/GuideContent';
import GuideSection from '../../components/GuideSection';
import DownloadGuideButton from './DownloadGuideButton';
import ContentList from './ContentList';
import MeditateSection from './MeditateSection';

const Mindset = () => {
  return (
    <>
      <GuideHeader
        name="Mindset"
        cdnId="app_images/mindset-meditate"
        text=" Your commitment to developing a growth mindset will help you to take control of your life. When you hear the critical voice in your head telling you that you can’t do something, reply with a growth mindset approach and tell yourself that you can."
      />
      <GuideContent>
        <GuideSection>
          <Typography variant="h5" gutterBottom>
            AFFIRMATIONS
          </Typography>
          <Typography variant="body1" gutterBottom>
            Speaking your  affirmations out loud daily and visualizing them will help you believe in what your are
            affirming and lead to self  empowerment.
          </Typography>
          <ContentList>
            <Typography variant="body1" gutterBottom>
              <strong>Download the ‘Think Up’ app</strong> and choose the affirmations you will record and say to
              yourself daily.
            </Typography>
            <Typography variant="body1" gutterBottom>
              <strong>Write out</strong> your affirmations and read them out loud daily.
            </Typography>
            <Typography variant="body1" gutterBottom>
              <strong>Make note cards</strong> of your affirmations and place them where you can see them every day.
            </Typography>
          </ContentList>
        </GuideSection>

        <GuideSection>
          <Typography variant="h5" gutterBottom>
            PEOPLE, PLACES, THINGS
          </Typography>
          <Typography variant="body1" gutterBottom>
            People often make the mistake not realizing that happiness is a choice. Your choices are heavily influenced
            by people in your lives, the places you go and the things that you do. Make adjustments in your life to line
            up with your goals. It is important to surround yourself with people who will support and encourage you
            along your journey. Positive social connection leads to long-term happiness.
          </Typography>
          <ContentList>
            <Typography variant="body1" gutterBottom>
              <strong>Keep a solid support system</strong> with people who support your mission (friends, family,
              coworkers, etc.)
            </Typography>
            <Typography variant="body1" gutterBottom>
              <strong>Go to places</strong> that support your goals and avoid ones that don't.
            </Typography>
            <Typography variant="body1" gutterBottom>
              <strong>Create hobbies</strong> that help you stay focused on your goals.
            </Typography>
          </ContentList>
        </GuideSection>
        <MeditateSection />

        <DownloadGuideButton storagePath="guides/mindset-guide.pdf" type="mindset" />
      </GuideContent>
      <SectionFooter />
    </>
  );
};

export default withAuthorization()(Mindset);
